import {Location} from "../../../pages/dove-siamo";
import Image from "next/image";
import {MapPin, MoveRight, Phone} from "lucide-react";

interface PointCardProps {
    locations: Location;
}

export const PointCard = ({ locations }: PointCardProps) => {

    return (


        <div className="bg-[#F8F9FD] flex flex-col border border-[#DBDBDB] rounded-2xl shadow-lg p-3 min-h-[370px] max-w-[300px]">
            {/* Immagine */}
            <div className="w-full overflow-hidden rounded-xl">
                <Image
                    src={locations.imgUrl}
                    alt={locations.title}
                    width={500}
                    height={352}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    className="object-cover"
                />
            </div>

            {/* Titolo */}
            <h3 className="font-semibold text-lg mt-4 text-gray-900">{locations.title}</h3>

            {/* Indirizzo */}
            <div className="flex items-center gap-2 text-gray-700 text-sm mt-2">
                <MapPin className="w-5 h-5 text-[#000D7D]" />
                <span className="leading-tight">{locations.address}</span>
            </div>

            {/* Telefono */}
            <div className="flex items-center gap-2 text-gray-700 text-sm mt-1">
                <Phone className="w-5 h-5 text-[#000D7D]" />
                <span className="leading-tight">{locations.phone}</span>
            </div>

            {/* Pulsante */}
            <div className="flex justify-end mt-auto">
                <button
                    className="flex items-center justify-center w-10 h-10 bg-[#000D7D] text-white rounded-full shadow-md transition-transform hover:scale-110"
                    onClick={() => window.location.href = locations.linkMaps}
                >
                    <MoveRight className="w-5 h-5" />
                </button>
            </div>
        </div>


    )


}

export default PointCard;
